
import Block from 'Mixins/Block';

export default Block('container-form', {
	onLoad (qComponent) {

		qComponent.child('.container-form__submit').addEvent('click', () => {

			qComponent.addClass('container-form--validate');

		});

	}
});
